export const determineEnvironment = (): string => {
  if (process.env.NETLIFY === 'true') {
    return process.env.CONTEXT || 'development';
  }
  return process.env.NODE_ENV || 'development';
};

export const defaultSentryConfig = {
  dsn: process.env.SENTRY_DSN,
  environment: determineEnvironment(),
  sampleRate: 1,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  beforeSend: (event: any, hint: any) => {
    // Do not send local errors to Sentry
    if (process.env.NETLIFY !== 'true') {
      console.log(
        'Sentry Error: ',
        hint.originalException || hint.syntheticException,
      );
      console.log('Sentry event: ', event);
      return null; // this drops the event and nothing will be sent to sentry
    }
    return event;
  },
};
